import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";
import axios from "axios";
import DeleteModal from "../../components/DeleteModal/DeleteModal";

function AdminBanner() {
  const [banners, setBanners] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null); 
  const token = localStorage.getItem("token");

  const dummyData = [
    { id: 1, title: "Summer Sale", status: "Active" },
    { id: 2, title: "Winter Collection", status: "Inactive" },
    { id: 3, title: "Flash Deal", status: "Active" }
  ];

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await USER_URL.get(
          `/products/admin/banner-create/`,
          
        );console.log(response);
        

        if (response.data?.Data?.length > 0) {
          setBanners(response.data.Data);
        } else {
          setBanners(dummyData);  // Use dummy data if no banners are found
        }
      } catch (error) {
        console.error("Error fetching banners:", error.message || error);
        setBanners(dummyData);  // Use dummy data on error
      }
    };

    fetchBanners();
  }, [token]);

  const handleDelete = async () => {
    if (selectedBanner) {
      try {
        await USER_URL.delete(`/products/admin/banner-create/${selectedBanner.id}/`);
        setBanners(banners.filter((b) => b.id !== selectedBanner.id));
        setShowConfirm(false);
        setSelectedBanner(null);
      } catch (error) {
        console.error("Error deleting banner:", error.message || error);
      }
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-medium text-green-600 ">Admin Banner</h1>
      {/* Header with Add New Banner Button */}
      <div className="flex justify-end items-center m-5">
        <Link
          to="/admin/add/banner"
          className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg shadow"
        >
          + Add New Banner
        </Link>
      </div>

      {/* Table Section */}
      <div className="overflow-auto mt-4">
        <table className="min-w-full text-center">
          <thead>
            <tr>
              <th className="py-2 text-green-500 text-md font-bold">Item No</th>
              <th className="px-2 py-2 text-green-500 text-md font-bold">Banner Name</th>
              <th className="px-2 py-2 text-green-500 text-md font-bold">Status</th>
              
            </tr>
          </thead>
          <tbody>
            {banners.length > 0 ? (
              banners.map((banner, index) => (
                <tr key={banner.id}>
                  <td className="py-3 px-3 text-sm ">
                    <div className="rounded-lg border border-gray-300 py-2 text-gray-800">
                      {index + 1}
                    </div>
                  </td>
                  <td className="py-3 px-2 text-sm ">
                    <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                      {banner.title || "N/A"}
                    </div>
                  </td>
                  <td className="py-3 px-2 text-sm ">
                    <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                      {banner.status || "Inactive"}
                    </div>
                  </td>
                  <td className="py-3 px-4 text-sm">
                    <div className="flex gap-4">
                      {/* Edit Button */}
                      <Link
                        to={`/admin/edit/banner/${banner.id}`}
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-blue-600 hover:text-white border border-blue-600 rounded-lg shadow-md hover:bg-blue-700 transition"
                      >
                        Edit
                      </Link>

                      {/* Delete Button */}
                      <button
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-red-600 hover:text-white border border-red-600 rounded-lg shadow-md hover:bg-red-700 transition"
                        onClick={() => {
                          setSelectedBanner(banner);
                          setShowConfirm(true);
                        }}
                      >
                        Delete
                      </button>

                      {/* View Button */}
                      <Link
                        to={`/admin/banner/view/${banner.id}`}
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-green-600 hover:text-white border border-green-600 rounded-lg shadow-md hover:bg-green-700 transition"
                      >
                        View
                      </Link>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-4 text-gray-600">
                  No banners found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="banner"
          title={selectedBanner?.title}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default AdminBanner;
